import * as React from 'react';
export const grabpaySvg = React.forwardRef(function grabpaySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8.695 3c1.028 0 1.77.113 2.387.363l.059.028v.855c-.606-.367-1.36-.531-2.446-.531-1.16 0-2.27.441-3.12 1.238-.813.766-1.29 1.793-1.31 2.828v.317c0 1.125.415 2.168 1.176 2.937a4.042 4.042 0 0 0 2.91 1.2c1.688 0 2.56-.598 2.938-.97l.02-.015.004-.004v-3.11H8.168v-.765h3.906v4.113l-.035.047c-.094.117-.383.442-.922.766-.785.465-1.715.703-2.765.703a4.804 4.804 0 0 1-3.438-1.422A4.894 4.894 0 0 1 3.5 8.18v-.328C3.5 5.222 5.879 3 8.695 3Zm0 1.277c.97 0 1.707.157 2.38.5l.066.035v.907c-.59-.489-1.282-.676-2.446-.676-1.664 0-3.074 1.258-3.105 2.762v.293c0 .761.285 1.472.808 2 .52.523 1.211.812 1.954.812.777 0 1.253-.137 1.527-.238l.148-.059h.008V9.461H8.168v-.762h2.582v2.293l-.02.016c-.187.18-.847.664-2.378.664-1.926 0-3.493-1.57-3.524-3.516v-.304c0-.946.406-1.84 1.145-2.52a3.995 3.995 0 0 1 2.722-1.055Zm0 0',
    }),
  );
});
grabpaySvg.defaultProps = {
  height: '16',
  viewBox: '0 0 16 16',
  width: '16',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var grabpay = {
  category: 'paymentmethod',
  colorable: true,
  name: 'grabpay',
  svg: grabpaySvg,
};
